var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag-list-base",class:{clickable: _vm.linkEnable}},_vm._l((_vm.tagListMod),function(item,index){return _c('li',{key:index,class:_vm.getItemClass(index),attrs:{"data-myid":item.id},on:{"click":function($event){$event.stopPropagation();_vm.onItemClick(index)}}},[_vm._v("#"+_vm._s(item.tagName))])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55bc5fb8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/TagList.vue
// module id = null
// module chunks = 